module.exports = __webpack_public_path__ + "img/businessThree.3c5d1223.svg";